import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Ensure the root element is available in the HTML document
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

// Render the React application
createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);